import Vue from "vue";
import Router from "vue-router";
import Auth from "./components/auth/Auth";
import LoginFacebookCallback from "./components/auth/LoginFacebookCallback";
import SignUp from "./components/auth/SignUp";
import Campaigns from "./components/Campaigns";
import AttachUserToCampaign from "./components/AttachUserToCampaign";
import DetachUserFromCampaign from "./components/DetachUserFromCampaign";
import CreateCharacter from "./components/CreateCharacter";
import CreateParty from "./components/CreateParty";
import CreateScenario from "./components/CreateScenario";
import CharacterClasses from "./components/CharacterClasses";
import CharacterClass from "./components/CharacterClass";
import AddPerkToCharacterClass from "./components/AddPerkToCharacterClass";
import Campaign from "./components/Campaign";
import Party from "./components/Party";
import Character from "./components/Character";
import ItemShop from "./components/ItemShop";
import GrantItem from "./components/GrantItem";
import UnlockDesign from "./components/UnlockDesign";
import AttachCharacterClass from "./components/AttachCharacterClass";
import Characters from "./components/Characters";
import MoveCharacterToUser from "./components/MoveCharacterToUser";

import store from './store/store';
import ScenarioView from "@/components/ScenarioView";

Vue.use(Router);

function requireAuth(to, from, next) {
  switch (to.meta.permission) {
    case "user":
      if (store.getters.canUser) {
        next();
      } else {
        next({name: "home"});
      }
      break;

    case "moderator":
      if (store.getters.canModerator) {
        next();
      } else {
        next({name: "home"});
      }
      break;

    case "admin":
      if (store.getters.canAdmin) {
        next();
      } else {
        next({name: "home"});
      }
      break;

    default:
      next({name: "home"});
      break;
  }
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Campaigns,
      meta: {
        title: 'Campaigns'
      }
    },
    {
      path: "/campaign/:campaignId",
      name: "campaign",
      component: Campaign,
      meta: {
        title: 'Campaign'
      }
    },
    {
      path: "/party/:partyId",
      name: "party",
      component: Party,
      meta: {
        title: 'Party'
      }
    },
    {
      path: "/scenario/:scenarioId/:partyId",
      name: "scenario",
      component: ScenarioView,
      meta: {
        title: 'Scenario'
      }
    },
    {
      path: "/character/:characterId",
      name: "character",
      component: Character,
      meta: {
        title: 'Character'
      }
    },
    {
      path: "/characters",
      name: "characters",
      component: Characters,
      meta: {
        title: 'Your Characters'
      }
    },
    {
      path: "/move_character_to_user/:characterId",
      name: "move-character-to-user",
      component: MoveCharacterToUser,
      meta: {
        title: 'Move Character to User'
      }
    },
    {
      path: "/item_shop/:characterId",
      name: "item-shop",
      component: ItemShop,
      meta: {
        title: 'Item Shop'
      }
    },
    {
      path: "/grant_item/:characterId",
      name: "grant-item",
      component: GrantItem,
      meta: {
        title: 'Grant Item'
      }
    },
    {
      path: "/unlock_design/:campaignId",
      name: "unlock-design",
      component: UnlockDesign,
      meta: {
        title: 'Unlock Design'
      }
    },
    {
      path: "/create_party/:campaignId",
      name: "create-party",
      component: CreateParty,
      meta: {
        title: 'Create Party'
      }
    },
    {
      path: "/create_scenario/:campaignId",
      name: "create-scenario",
      component: CreateScenario,
      meta: {
        title: 'Create Scenario'
      }
    },
    {
      path: "/attach_character_class/:campaignId",
      name: "attach-character-class",
      component: AttachCharacterClass,
      meta: {
        title: 'Unlock Class'
      }
    },
    {
      path: "/create_character/:partyId",
      name: "create-character",
      component: CreateCharacter,
      meta: {
        title: 'Create Character'
      }
    },
    {
      path: "/attach_user_to_campaign/:campaignId",
      name: "attach-user-to-campaign",
      component: AttachUserToCampaign,
      meta: {
        title: 'Attach User to Campaign'
      }
    },
    {
      path: "/detach_user_from_campaign/:campaignId",
      name: "detach-user-from-campaign",
      component: DetachUserFromCampaign,
      meta: {
        title: 'Detach User from Campaign'
      }
    },
    {
      path: "/character_classes",
      name: "character-classes",
      component: CharacterClasses,
      beforeEnter: requireAuth,
      meta: {
        title: 'Classes',
        permission: 'moderator'
      }
    },
    {
      path: "/character_class/:characterClassId",
      name: "character-class",
      component: CharacterClass,
      beforeEnter: requireAuth,
      meta: {
        title: 'Class',
        permission: 'moderator'
      }
    },
    {
      path: "/add_perk_to_character_class/:characterClassId",
      name: "add-perk-to-character-class",
      component: AddPerkToCharacterClass,
      beforeEnter: requireAuth,
      meta: {
        title: 'Add Perk to Class',
        permission: 'moderator'
      }
    },
    {
      path: "/auth",
      name: "auth",
      component: Auth,
      meta: {
        title: 'Login'
      }
    },
    {
      path: "/signup",
      name: "signup",
      component: SignUp,
      meta: {
        title: 'Sign Up'
      }
    },
    {
      path: '/login/facebook/callback/:userId/:userType/:accessToken',
      name: 'loginFacebookCallback',
      component: LoginFacebookCallback,
    },
    // Leave this route at the end of the file. That way, it works as a catch-all for all the faulty routes
    // the user might type in the address field regarding our website.
    {
      path: "*",
      redirect: "/"
    }
  ]
});
